import { UnitCategoryCode } from 'funds-model';


export enum ROI {
  M1 = '1M',
  M3 = '3M',
  M6 = '6M',
  M12 = '12M',
  M36 = '36M',
  M60 = '60M',
  YTD = 'YTD'
}

const fundListOptions = {
  roi: [
    ROI.M1,
    ROI.M3,
    ROI.M6,
    ROI.M12,
    ROI.M36,
    ROI.M60,
    ROI.YTD,
  ],
  horizon: [
    { label: '1-years', filter: { number: 1 } },
    { label: '2-years', filter: { number: 2 } },
    { label: '3-years', filter: { number: 3 } },
    { label: '4-years', filter: { number: 4 } },
    { label: '5-years', filter: { number: 5 } }
  ],
  unitCategoryCode: [
    { label: 'code-a', code: UnitCategoryCode.A},
    { label: 'code-e', code: UnitCategoryCode.E},
    { label: 'code-f', code: UnitCategoryCode.F},
    { label: 'code-k', code: UnitCategoryCode.K},
    { label: 'code-s', code: UnitCategoryCode.S},
    { label: 'code-t', code: UnitCategoryCode.T},
    { label: 'code-w', code: UnitCategoryCode.W},
  ]
};

export default fundListOptions;
